import { memo, type PropsWithChildren } from "react";
import { useLocales } from 'locales';
import Stack, { StackProps } from "@mui/material/Stack";
import Button, { type ButtonProps } from "@mui/material/Button";
import Box from "@mui/material/Box";
import { useNavigate } from "infrastructure/router";
import { WebRoutes } from "consts/enpoints/web";

type Props = StackProps & {
    readonly actionProps?: ButtonProps;
};

const Documentation = ({ children, actionProps = {}, ...restProps }: PropsWithChildren<Props>) => {
    const { translate } = useLocales();
    const navigate = useNavigate();

    return (
        <Stack
            spacing={3}
            {...restProps}
            sx={{
                px: 5,
                pb: 5,
                mt: 10,
                width: 1,
                display: 'block',
                textAlign: 'center',
                ...restProps.sx
            }}
        >
            <Box
                component="img"
                src="/assets/illustrations/illustration_docs.svg"
            />
            {children}
            <Button
                onClick={() => navigate(WebRoutes.Documentation)}
                variant='contained'
                {...actionProps}
            >
                <>{actionProps.children ?? translate('docs.documentation')}</>
            </Button>
        </Stack>
    );
};

export default memo(Documentation);
